import { QueryKey, useQuery, UseQueryOptions } from "react-query";
import { BILLING_ENDPOINT } from "./constants";
import useFetchWithAuth from "@/fetch/fetchWithAuth";

export enum InvoiceStatusText {
  Pending = "Pending",
  Paid = "Paid",
  OnHold = "On Hold",
  Cancelled = "Cancelled",
  Expired = "Expired",
}

type Result = {
  id: number;
  tid: number;
  expires_at: number | null;
  currency: string;
  status: string;
  department_id: number;
  deposit: number;
  use_excess: number;
  type: "trip" | "travel";
  is_public: number;
  offset: null | number;
  _ca: number;
  _cb: number;
  _lma: number;
  _lmb: number;
  deposit_paid_at: number;
  net: number;
  markup: number;
  tax: number;
  total: number;
  discount: number;
  paid: number;
  processed_refund: number;
  pending_refund: number;
  donations: number;
  credit: number;
  outstanding: number;
  is_expired: number;
  time_remaining: null | number;
  cid: number;
  sales_register_id: number;
  trip_division: string;
  trip_destination: string;
  trip_code: string;
  trip_duration: string;
  office_name: string;
  currency_symbol: string;
  staff_id: number;
  status_data: { status: string; statusText: InvoiceStatusText };
};
type QueryError = {};

const useInvoiceQuery = (
  invoiceId: number | undefined,
  options?: UseQueryOptions<Result, QueryError, Result, QueryKey>
) => {
  const url = `${BILLING_ENDPOINT}/invoices/${invoiceId}`;
  const { fetchWithAuth } = useFetchWithAuth();
  const cacheKey = [url, invoiceId];

  return useQuery<Result, QueryError>(
    cacheKey,
    async () => {
      if (!invoiceId) throw new Error();

      const res = await fetchWithAuth<Result>(url);

      return res;
    },
    {
      enabled: !!invoiceId,
      ...options,
    }
  );
};
export default useInvoiceQuery;
